const FAKE_SCROLLBAR_DEFAULT_PROPS = {
  appearance: 'none',
  width: { base: '1', sm: '2' },
  height: { base: '1', sm: '2' },
  zIndex: 'banner',
} as const;

const FAKE_SCROLLBAR_STYLES = {
  borderRadius: { base: 0, sm: 'base' },
  backgroundColor: { base: 'rgba(0,0,0,.3)', sm: 'rgba(0,0,0,.5)' },
  zIndex: 'banner',
} as const;

export const layerStyles = {
  form: {
    bgColor: 'grey.50',
    color: 'grey.900',
  },
  dashed: {
    borderRadius: 3,
    border: '1px dashed',
    borderColor: 'blue.200',
    opacity: '0.5',
  },
  scrollbarAlwaysVisible: {
    '::-webkit-scrollbar': FAKE_SCROLLBAR_DEFAULT_PROPS,
    '::-webkit-scrollbar-thumb': FAKE_SCROLLBAR_STYLES,
  },
  hScrollbarAlwaysVisible: {
    '::-webkit-scrollbar': {
      ...FAKE_SCROLLBAR_DEFAULT_PROPS,
      width: '0',
    },
    '::-webkit-scrollbar-thumb': FAKE_SCROLLBAR_STYLES,
  },
  vScrollbarAlwaysVisible: {
    '::-webkit-scrollbar': {
      ...FAKE_SCROLLBAR_DEFAULT_PROPS,
      height: '0',
    },
    '::-webkit-scrollbar-thumb': FAKE_SCROLLBAR_STYLES,
  },
};
